import { call, put, takeLatest } from "redux-saga/effects";

import { ApiService } from "pwapi";

import {
  USERS_LIST_SUCCESS,
  USERS_LIST_REQUEST,
  USERS_LIST_FAILURE,
} from "../actions/constants";

function* fetchUsers(action: any): any {
  try {
    const result = yield call(ApiService.listUsers, action.payload);
    yield put({ type: USERS_LIST_SUCCESS, payload: result });
  } catch (e) {
    yield put({
      type: USERS_LIST_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* listUsersSaga() {
  yield takeLatest(USERS_LIST_REQUEST, fetchUsers);
}
